import { CheckCircleFilled, RightOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Image, message, Row, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { Icons } from '../../../controller/Images';
import { useNavigate } from 'react-router-dom';
import { useTimerStore } from '../../../store/timerReducer';
import routes from '../../../controller/Routes';
import { goFullScreen } from '../../../controller/Fullscreen';
import { getCandidateToken } from '../../../controller/localStroageHandler';
import { usecandidateSidebarStore } from '../../../store/candidateSidevarReducer';
import { usecandidateTestStore } from '../../../store/candidateReducer';
import { getTest, gettestDetail } from '../../../controller/api/candidateServices';
import { useVideoStreamStore } from '../../../store/CamareStreamResucer';
// import { AddNotification } from '../../../controller/api/authServices';

const Introduction = ({ current, setCurrent }) => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [CameraandmicActive, setIsCameraandmicActive] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { updateTimer } = useTimerStore((state) => state);
  const [detailData, setDetailData] = useState(null);
  const [loading, setloading] = useState(false);
  const { updateMenuItem } = usecandidateSidebarStore((state) => state);
  const {updateStream} = useVideoStreamStore()
  const { updatetestquestions, updateStartTime } = usecandidateTestStore(
    (state) => state
  );

  useEffect(() => {
    let testid = localStorage.getItem('testid')
    if (testid) {
      navigate(routes.test.question);
    }
  }, [])
  const handleStartTest = async() => {
    // updateTimer(10, 0);
    // goFullScreen(document.documentElement);
    // navigate(routes.test.question);
    setloading(true);
    let isPermissionGranted =await checkPermissions();
    if(isPermissionGranted){
      getTest().then(res => {
        let sidebardata = res?.data?.data?.test_questions?.map(
          (val, index) => {
            return {
              name: val?.section?.toLowerCase(),
              totalquestion: val?.questions?.length,
              totalanswer: 0,
              complete: 0,
            };
          }
        );
        updateMenuItem(sidebardata);
        updatetestquestions(res?.data?.data?.test_questions);
        localStorage.setItem('testName', res?.data?.data?.name);
        localStorage.setItem('testid', res?.data?.data?._id);
        updateTimer(res?.data?.data?.durationInMins, 0);
        goFullScreen(document.documentElement);
        const now = new Date();
        const currentTimeInISOString = now.toISOString();
        updateStartTime(currentTimeInISOString);
        setloading(false)
        navigate(routes.test.question);
      }).catch(err => { console.log("err ===>", err) })
    }else{
      message.error('Please Allow Camera and Mic Access')
      setIsCameraandmicActive(false);
    }
    

    // gettestquestion({ jwt_token: getCandidateToken() })
    //   .then((res) => {
    //     let userdetail = JSON.parse(localStorage.getItem('userdetail'));
    //     const msgpayload = {
    //       message: `<span className='' style={{ fontSize: '14px' }}>
    //       ${userdetail?.user?.first_name}  ${userdetail?.user?.last_name}
    //       <span className='text-muted'>Just Started</span> ${res?.data?.test_details?.name}
    //     </span>`,
    //       is_seen: false,
    //       created_by: userdetail?.user?.id,
    //       name: userdetail?.user?.first_name,
    //     };
    //     AddNotification(msgpayload)
    //       .then((res) => {
    //         console.log(res, 'flmflfmfl');
    //       })
    //       .catch((err) => console.log('err ====>', err));
    //     let sidebardata = res?.data?.test_details?.test_questions?.map(
    //       (val, index) => {
    //         return {
    //           name: val?.section?.toLowerCase(),
    //           totalquestion:val?.questions?.length,
    //           totalanswer:0,
    //           complete: 0,
    //         };
    //       }
    //     );
    //     updateMenuItem(sidebardata);
    //     updatetestquestions(res?.data?.test_details?.test_questions);
    //     localStorage.setItem('testName', res?.data?.test_details?.name);
    //     localStorage.setItem('testid', res?.data?.test_details?.id);
    //     updateTimer(res?.data?.test_details?.duration_in_min, 0);
    //     goFullScreen(document.documentElement);
    //     const now = new Date();
    //     const currentTimeInISOString = now.toISOString();
    //     updateStartTime(currentTimeInISOString);
    //     navigate(routes.test.question);
    //   })
    //   .catch((err) => {
    //     console.log('err ====>', err);
    //   });
  };
  useEffect(() => {
    setloading(true);
    gettestDetail()
      .then((res) => {
        console.log('res=ddddddddd====>', res);
        setDetailData(res?.data?.testDetails);
        setloading(false);
      })
      .catch((err) => console.log('err=======>', err));
  }, []);

 
const hanldeCameraAndmicAccess = async () => {
  setIsCameraandmicActive(false);
  setBtnLoading(true)
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
    if (stream) {
      updateStream(stream); 
      setIsCameraandmicActive(true);
      setBtnLoading(false)
    }
  } catch (error) {
    console.error("Error accessing camera and microphone:", error);
  }
};
function checkPermissions() {
  return Promise.all([
    navigator.permissions.query({ name: 'camera' }),
    navigator.permissions.query({ name: 'microphone' })
  ])
  .then(results => {
    const cameraPermissionGranted = results[0].state === 'granted';
    const micPermissionGranted = results[1].state === 'granted';

    // Return true if both permissions are granted, else false
    if (cameraPermissionGranted && micPermissionGranted) {
      return true;
    } else {
      return false;
    }
  })
  .catch((error) => {
    console.log('Permission check failed', error);
    return false;
  });
}

return (
  <div className='w-100 h-100 introduction-page custom-font-family-poppins'>
    <div className="d-flex flex-column gap-3 pb-1">
      <div>
        <div className='step-text'>
          <span className='text-color-custom fw-bold '>
            Step {current + 1}{' '}
          </span>
          of 2
        </div>
        <span className='title '>Test Guide Lines</span>
      </div>

      <Row className='introduction-detail'>
        <Col xl={6} lg={8} md={12} sm={15} xs={24} className='d-flex flex-column gap-2 '>
          <Row className=''>
            <Col
              span={16}
              className='custom-font-18 fw-semibold custom-font-family-poppins'
            >
              Test duration :
            </Col>
            <Col
              span={8}
              className='d-flex justify-content-end custom-font-18 custom-font-family-poppins'
            >
              {detailData?.durationInMins} min
            </Col>
          </Row>
          <Row>
            <Col
              span={16}
              className='custom-font-18 fw-semibold custom-font-family-poppins'
            >
              Number of Questions:
            </Col>
            <Col
              span={8}
              className='d-flex justify-content-end custom-font-18 custom-font-family-poppins'
            >
              {detailData?.numberOfQuestions}
            </Col>
          </Row>
          {detailData?.section_details?.map((val, index) => {
            return (
              <Row>
                <Col
                  span={16}
                  className='custom-font-18 custom-font-family-poppins'
                >
                  <span className='fw-semibold'> Section {index + 1} :</span>{' '}
                  {val?.section}
                </Col>
                <Col
                  span={8}
                  className='d-flex justify-content-end custom-font-family-poppins'
                >
                  <div className='section-total-question'>
                    {val?.questionsLength} Ques
                  </div>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
      <Row className='instruction-container'>
        <Col span={24} className='heading'>
          Instructions
        </Col>
        <Col span={24} className=''>
          <ul>
            <li>Don’t forget to submit your test once you are done.</li>
            <li>Test will be submitted automatically if browser tab changed.</li>
            <li>Make sure you have a stable internet connection.</li>
            <li>Test will be Submitted automatically if connection lost.</li>
            <li>Give camera and mic Access {CameraandmicActive?<CheckCircleFilled style={{color:'green'}} />:<Button loading={btnLoading} className='button-color' type='primary' onClick={() => { hanldeCameraAndmicAccess() }}>Allow Access</Button>}</li>
          </ul>
        </Col>
      </Row>
      <Row span={24} className='start-test-btn'>
        <Col lg={4} md={8} sm={10} xs={14}>
          <Button
            type='primary'
            htmlType='submit'
            className='w-100 h-auto button-color p-2 d-flex justify-content-center align-items-center'
            onClick={() => handleStartTest()}
            disabled={CameraandmicActive==false?true:false}
            loading={loading}
          >
            Start Test <RightOutlined />
          </Button>
        </Col>
      </Row>
    </div>
  </div>
  // <div className='w-100 h-100 p-5 pt-2 pb-0'>
  //   <Spin tip='Loading...' spinning={loading}>
  //     <div className='d-flex flex-column justify-content-between h-100'>
  //       <Row>
  //         <Col
  //           lg={12}
  //           md={16}
  //           sm={18}
  //           xs={24}
  //           className='d-flex flex-column gap-3'
  //         >
  //           <span className='fs-1 fw-medium'>Test Guide Lines</span>
  //           <ul>
  //             <li>
  //               Test duration : {detailData?.test_details?.duration_in_min}{' '}
  //               min
  //             </li>
  //             <li>
  //               Total {questionCount(detailData?.section_details)} questions
  //               divided into{' '}
  //               <span className='fw-bold'>
  //                 {detailData?.section_details?.length} sections.
  //               </span>
  //             </li>
  //             <li>You are not allowed to change your tab.</li>
  //           </ul>
  //           <Row>
  //             {detailData?.section_details?.map((val, index) => {
  //               return (
  //                 <Col lg={6} md={8} sm={8} xs={8}>
  //                   <div className='d-flex flex-column justify-content-center align-items-center gap-2'>
  //                     <Image
  //                       src={
  //                         val?.section_name?.toLowerCase() == 'analytical'
  //                           ? Icons.analyticalIcon
  //                           : val?.section_name?.toLowerCase() == 'coding'
  //                           ? Icons.codingIcon
  //                           : Icons?.theoryIcon
  //                       }
  //                       alt=''
  //                       width={'80px'}
  //                       height={'80px'}
  //                       preview={false}
  //                     />
  //                     <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
  //                       <h4>Section {index + 1}</h4>
  //                       <span style={{ fontSize: '16px', fontWeight: '500' }}>
  //                         {val?.section_name}
  //                       </span>
  //                       <hr className='m-1 w-75' />
  //                       <span className='fw-semibold text-muted'>
  //                         {val?.question_count} Ques
  //                       </span>
  //                     </div>
  //                   </div>
  //                 </Col>
  //               );
  //             })}
  //           </Row>
  //         </Col>
  //       </Row>
  // <Row span={24} className='mt-5'>
  //   <Col lg={4} md={8} sm={10} xs={14}>
  //     <Button
  //       type='primary'
  //       htmlType='submit'
  //       className='w-100 h-auto button-color p-2 d-flex justify-content-center align-items-center'
  //       onClick={() => handleStartTest()}
  //     >
  //       Start Test <RightOutlined />
  //     </Button>
  //   </Col>
  //   <Col
  //     lg={4}
  //     md={7}
  //     sm={10}
  //     xs={10}
  //     className='d-flex justify-content-center align-items-center gap-1 '
  //   >
  //     <span className='text-color-custom fw-bold'>
  //       Step {current + 1}{' '}
  //     </span>
  //     of 2
  //   </Col>
  // </Row>
  //     </div>
  //   </Spin>
  // </div>
);
};

export default Introduction;
